import scanSuccess from "./scan_success.mp3";
import alertNoise from "./alert_noise.mp3";
// AudioManager.js
export const alertAudio = new Audio(alertNoise);
export const successAudio = new Audio(scanSuccess);

// Do not call play() here — just preload
alertAudio.preload = 'auto';
successAudio.preload = 'auto';
export {
scanSuccess,
alertNoise
}